// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomersFilters-module__root__3v-ii","filters-row":"CustomersFilters-module__filters-row__2GtaT","filters-row-header":"CustomersFilters-module__filters-row-header__HWL01"};